<template>
  <div
    class="text-sm text-center font-semibold"
  >
    <div
      v-if="compact"
      class="w-[92px]"
    >
      {{ qty }}
    </div>
    <div v-else>
      {{ bigQuantity }}
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ProductCardQuantity',
  props: {
    qty: {
      type: Number,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {

    const i18n = useI18n();
    const bigQuantity = computed(() => `${i18n.t('Quantity')}: ${props.qty}`);

    return {
      bigQuantity,
    };
  
  },
});

</script>
